(function() {
  'use strict';

  angular
    .module(
      'app',
      [
        'ngAnimate',
        'ngSanitize',
        'ngAria',
        'ui.router',
        'ui.bootstrap',
        'toastr',
        'ngProgress',
        'ng-showdown'
      ]
    );

})();

(function() {
  'use strict';

  /** @ngInject */
  angular.module('app').controller(
    'HomeController',
    function HomeController(HomeResolve) {
      var _self = this;

      _self.home = HomeResolve;
    }
  );

})();

(function() {
  'use strict';

  /** @ngInject */
  angular.module('app').controller(
    'DocController',
    function DocController(DocResolve) {
      var _self = this;

      _self.doc = DocResolve;
    }
  );

})();

(function() {
  'use strict';

  /** @ngInject */
  angular.module('app').controller(
    'BaseController',
    function BaseController(VersionsResolve, $http) {
      var _self = this;

      _self.versions = VersionsResolve;
      _self.currentVersion = 
      _self.classes = [];


      for (var i = 0; i < _self.versions.length; i++) {
        if (_self.versions[i].stable) {
          _self.currentVersion = _self.versions[i];
          $http.get('assets/markdown/' + _self.versions[i].version + '/map.json').then(function (response) {
            for (var j = 0; j < response.data.length; j++) {
                _self.classes.push({
                    version: _self.currentVersion.version,
                    path: response.data[j].fileName,
                    label: response.data[j].label
                });
            }
          });
        }
      }

    }
  );

})();

(function() {
  'use strict';

  /** @ngInject */
  angular.module('app').service(
    'MarkdownService',
    function MarkdownService($q, $http) {
      var _self = this;

      _self.getMd = function (md) {
        return $http.get(md).then(function (response) {
          return response.data;
        });
      };

      _self.getAssetsMd = function (md) {
        return $http.get('assets/markdown/' + md).then(function (response) {
          return response.data;
        });
      };
    }
  );

})();

(function() {
  'use strict';

  /** @ngInject */
  angular.module('app').run(
    function run($rootScope, ngProgress) {
      $rootScope.$on('$stateChangeStart', function () {
        ngProgress.start();
      });

      $rootScope.$on('$stateChangeSuccess', function () {
        ngProgress.complete();
      });
    }
  );

})();

(function() {
  'use strict';

  /** @ngInject */
  angular.module('app').config(
    function routerConfig($stateProvider, $urlRouterProvider) {

      /** @ngInject */
      var HomeResolve = function (MarkdownService) {
        return MarkdownService.getMd('https://raw.githubusercontent.com/gabrielrcouto/php-gui/master/README.md').then(function (data) {
          return data;
        });
      };

      /** @ngInject */
      var VersionsResolve = function ($http) {
        return $http.get('assets/versions.json').then(function (response) {
          return response.data;
        });
      };

      /** @ngInject */
      var DocResolve = function ($stateParams, MarkdownService) {
        return MarkdownService.getAssetsMd($stateParams.version + '/' + $stateParams.path).then(function (data) {
          return data;
        });
      };

      var states = [
        {
          stateName: 'root',
          stateData: {
            abstract: true,
            templateUrl: 'app/views/base/base.html',
            controller: 'BaseController',
            controllerAs: 'controller',
            resolve: {
              'VersionsResolve': VersionsResolve
            }
          }
        },
        {
          stateName: 'root.home',
          stateData: {
            url: '/home',
            views: {
              'content': {
                templateUrl: 'app/views/base/home/home.html',
                controller: 'HomeController',
                controllerAs: 'controller',
                resolve: {
                  'HomeResolve': HomeResolve
                }
              }
            }
          }
        },
        {
          stateName: 'root.doc',
          stateData: {
            url: '/:version/:path',
            views: {
              'content': {
                templateUrl: 'app/views/base/doc/doc.html',
                controller: 'DocController',
                controllerAs: 'controller',
                resolve: {
                  'DocResolve': DocResolve
                }
              }
            }
          }
        },

      ];

      angular.forEach (states, function (state) {
        $stateProvider.state(state.stateName, state.stateData);
      });

      $urlRouterProvider.otherwise('/home');
    }
  );

})();
/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('app')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  /** @ngInject */
  angular.module('app').config(
    function config(ngProgressProvider) {
      // ngProgress Configuration
      ngProgressProvider.setColor('#9C9C9C');
      ngProgressProvider.setHeight('4px');
    }
  );

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/views/base/base.html","<nav class=\"navbar navbar-inverse navbar-fixed-top\"><div class=\"container-fluid\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#navbar\" aria-expanded=\"false\" aria-controls=\"navbar\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"navbar-brand\" href=\"javascript://\" ui-sref=\"root.home\">PHP-GUI</a> <a class=\"navbar-brand\" href=\"javascript://\" ng-repeat=\"version in controller.versions\" ng-click=\"version.version\">{{ version.label }} {{ version.stable ? \'- Stable\' : \'\' }}</a></div></div></nav><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-sm-3 col-md-2 sidebar\"><ul class=\"nav nav-sidebar\"><li><a href=\"javascript://\" ui-sref=\"root.home\">Home</a></li></ul><h4>Classes - {{ controller.currentVersion.label }}</h4><ul class=\"nav nav-sidebar\"><li ng-repeat=\"classe in controller.classes\"><a href=\"javascript://\" ui-sref=\"root.doc({ version: classe.version, path: classe.path })\">{{ classe.label }}</a></li></ul></div><div class=\"col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main\"><div ui-view=\"content\"></div></div></div></div>");
$templateCache.put("app/views/base/doc/doc.html","<div markdown-to-html=\"controller.doc\"></div>");
$templateCache.put("app/views/base/home/home.html","<div markdown-to-html=\"controller.home\"></div>");}]);